import { Button, Icon } from "@blueprintjs/core";
import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import { ImportStore } from "../../stores/import/ImportStore";
import { toast } from "react-toastify";
import { MDBCol, MDBRow } from "mdbreact";
import Dropzone from "react-dropzone";
require("../../assets/css/components/ImportPage.css");

@observer
export default class ImportNFCEPage extends React.Component<{}, any> {
  constructor(props: any) {
    super(props);
  }

  handleFileDropSaida = async (files: any) => {

    let niveis_acesso = AppStore.obs1.usuario ? AppStore.obs1.usuario.niveis_acesso : [""];

    if (niveis_acesso.indexOf("i1") == -1) {
      toast.warning("Você não possui permissão para importar NF-es", {});
      return
    }

    if (ImportStore.obs.selectedEmpresaImport.razao_social == "") {
      toast.warning("Você precisa selecionar uma Empresa", {});
      return
    }

    var data = new FormData();

    data.append("file", files[0])
    data.append("descricao", ImportStore.obs.descricao_import)
    data.append("tipo", "saida")
    data.append("modelo", "nfce")
    data.append("estado", ImportStore.obs.selectedEmpresaImport.uf.toLowerCase())
    data.append("cnpj", ImportStore.obs.selectedEmpresaImport.cnpj)
    data.append("rewritexml", ImportStore.obs.rewritexml)

    await ImportStore.handldeCreateTaskImport(data);
  };

  handleFileDropEntrada = async (files: any) => {

    let niveis_acesso = AppStore.obs1.usuario ? AppStore.obs1.usuario.niveis_acesso : [""];

    if (niveis_acesso.indexOf("i1") == -1) {
      toast.warning("Você não possui permissão para importar NF-es", {});
      return
    }

    if (ImportStore.obs.selectedEmpresaImport.razao_social == "") {
      toast.warning("Você precisa selecionar uma Empresa", {});
      return
    }

    var data = new FormData();

    data.append("file", files[0])
    data.append("descricao", ImportStore.obs.descricao_import)
    data.append("tipo", "entrada")
    data.append("modelo", "nfce")
    data.append("estado", ImportStore.obs.selectedEmpresaImport.uf.toLowerCase())
    data.append("cnpj", ImportStore.obs.selectedEmpresaImport.cnpj)
    data.append("rewritexml", ImportStore.obs.rewritexml)

    await ImportStore.handldeCreateTaskImport(data);

  };
  handleFileDropRejected = async (files: any) => {
    if (files.length > 1) {
      toast.warning("Apenas um arquivo por vez é liberado para importação.", {});
      return;
    }

    toast.warning("Arquivo inválido, é aceito somente arquivos .zip", {});
    return;
  };

  render() {
    return (
      <>
        <div className="import-page">
          <MDBRow>
            <MDBCol xl="6" lg="6" md="6" sm="6" xs="12" data-tut="importacao">
              <Dropzone
                accept={{
                  "files/zip": [".zip"],
                }}
                maxFiles={1}
                multiple={false}
                onDropAccepted={this.handleFileDropEntrada}
                onDropRejected={this.handleFileDropRejected}
              >
                {({ getRootProps, getInputProps }) => (
                  <>
                    <div {...getRootProps()} style={{ marginBottom: 30 }}>
                      <input {...getInputProps()} />
                      <Button
                        icon="upload"
                        text="Selecionar NFC-es de ENTRADA para upload"
                        className="btn-file btnDefault noMargin"
                      />
                    </div>

                    <div {...getRootProps()} className="nz-upload-box">
                      <input {...getInputProps()} />
                      <Icon icon="upload" iconSize={60} />
                      <span style={{ marginLeft: 20 }}>
                        Arrastar um arquivo de <b>ENTRADA</b> para importar.{" "}
                        <br />
                        <b>(Máx. 300 mb)</b>
                      </span>
                    </div>
                  </>
                )}
              </Dropzone>
            </MDBCol>

            <MDBCol xl="6" lg="6" md="6" sm="6" xs="12" data-tut="importacao">
              <Dropzone
                accept={{
                  "files/zip": [".zip"],
                }}
                maxFiles={1}
                multiple={false}
                onDropAccepted={this.handleFileDropSaida}
                onDropRejected={this.handleFileDropRejected}
              >
                {({ getRootProps, getInputProps }) => (
                  <>
                    <div {...getRootProps()} style={{ marginBottom: 30 }}>
                      <input {...getInputProps()} />
                      <Button
                        icon="download"
                        text="Selecionar NFC-es de SAÍDA para upload"
                        className="btn-file btnDefault noMargin"
                      />
                    </div>

                    <div {...getRootProps()} className="nz-upload-box">
                      <input {...getInputProps()} />
                      <Icon icon="download" iconSize={60} />
                      <span style={{ marginLeft: 20 }}>
                        Arrastar um arquivo de <b>SAÍDA</b> para importar.{" "}
                        <br />
                        <b>(Máx. 300 mb)</b>
                      </span>
                    </div>
                  </>
                )}
              </Dropzone>
            </MDBCol>
          </MDBRow>
        </div>
      </>
    );
  }
}
